import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Renders nothing when the case is not urgent — urgency styling
 * should only ever appear when patient.urgent === true.
 */
export default function UrgentBadge({ size = "md" }) {
  const isSmall = size === "sm";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold
        bg-[#FEF2F2] text-[#B91C1C] border border-[#FCA5A5]
        ${isSmall ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs"}`}
    >
      <AlertTriangle className={isSmall ? "w-3 h-3" : "w-3.5 h-3.5"} />
      URGENT
    </span>
  );
}
